import React from "react";
import { Row } from 'antd';

import { useActiveMenuItem } from "components/use-hooks";
import { TranslateTableAll } from "components/translate";

const TranslatesPage = () => {

    useActiveMenuItem( ["translations-all"], ["translations"] );

    return(
        <Row justify="center" className="page page-translates fullscreen">
            <TranslateTableAll />
        </Row>
    
    );
};

export default TranslatesPage;